import { hasKeys, IReportCriteriaFiltersSchemaValues } from "@ryde/shared";

export const clearValuesFilterStoreObjReports = (
  filterObj: IReportCriteriaFiltersSchemaValues,
): IReportCriteriaFiltersSchemaValues => {
  if (!filterObj || !hasKeys(filterObj)) {
    return {};
  }

  const obj = Object.keys(filterObj).reduce(
    (accumulator, filterKey) => ({ ...accumulator, [filterKey]: null }),
    {} as IReportCriteriaFiltersSchemaValues,
  );

  return obj;
};
